import { ACTIONS } from "../01-actions/mmp";

const initialState = {
  status: null,
  mmpStatus: null,
  mmpCharges: [],
  pages: null,
  totalTCT: 0,
  totalUSD: 0,
  error: null,
  mmpStatisticChargeByStatus: {},
  note: null,
  totalCCT: 0,
  totalROY: 0,
  mmpCurrencyBalance: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    // PROGRESS
    case ACTIONS.MMP_GET_CHARGE_PROGRESS:
    case ACTIONS.MMP_SEARCH_CHARGE_PROGRESS:
    case ACTIONS.MMP_GET_STATISTIC_CHARGE_BY_STATUS_PROGRESS:
    case ACTIONS.MMP_CHANGE_STATUS_TOP_UP_PROCESS:
    case ACTIONS.MMP_GET_CURRENCY_BALANCE_PROGRESS:
      return {
        ...state,
        status: action.type,
      };
    // SUCCESS
    case ACTIONS.MMP_GET_CHARGE_SUCCESS:
    case ACTIONS.MMP_SEARCH_CHARGE_SUCCESS:
      return {
        ...state,
        mmpStatus: action.type,
        mmpCharges: action.data.charges,
        pages: action.data.pages,
        totalTCT: action.data.totalTCT || 0,
        totalUSD: action.data.totalUSD || 0,
        totalCCT: action.data.totalCCT || 0,
        totalROY: action.data.totalROY || 0,
      };
    case ACTIONS.MMP_GET_CURRENCY_BALANCE_SUCCESS:
      return{
        ...state,
        status: action.type,
        mmpCurrencyBalance: action.data.currencyBalance,
      }
    case ACTIONS.MMP_GET_STATISTIC_CHARGE_BY_STATUS_SUCCESS:
      return {
        ...state,
        status: action.type,
        mmpStatisticChargeByStatus: action.data.statisticChargeByStatus,
      };
    // FAILED
    case ACTIONS.MMP_GET_CHARGE_FAIL:
    case ACTIONS.MMP_SEARCH_CHARGE_FAIL:
      return {
        ...state,
        mmpStatus: action.type,
        error: action.data.error,
        mmpCharges: [],
      };
    case ACTIONS.MMP_GET_STATISTIC_CHARGE_BY_STATUS_FAIL:
    case ACTIONS.MMP_GET_CURRENCY_BALANCE_FAIL:
    case ACTIONS.MMP_CHANGE_STATUS_TOP_UP_FAIL:
      return {
        ...state,
        status: action.type,
        error: action.data.error,
      };
    case ACTIONS.MMP_CLEAR_STATUS:
      return {
        ...state,
        status: null,
        mmpStatus: null,
      };
    default:
      return state;
  }
};
